/* src/app/components/attributes-modal/attributes-modal.component.css */
.hr {
  border-top: 1px solid #0071bb;
}
.centerText {
  text-align: center;
}
.no-right-padding {
  padding-right: 0px;
}
.e-acrdn-header-content {
  font-size: 20px !important;
  font-family: open_sansregular, sans-serif !important;
  color: #0071bb !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  cursor: pointer !important;
  width: 98%;
}
.e-acrdn-header .e-checkbox-wrapper .e-label,
.e-css.e-checkbox-wrapper .e-label {
  color: #0071bb !important;
}
.header-span {
  font-size: 12px;
  padding-right: 15px;
}
.accordion-links,
.selectedBoxes {
  font-size: 13px;
  margin-bottom: 10px;
}
.selected-numbers {
  padding: 0 0 0 20px;
}
.e-acrdn-header-content .e-checkbox-wrapper .e-label,
.e-css.e-checkbox-wrapper .e-label {
  font-size: 16px !important;
}
.e-checkbox-wrapper .e-label,
.e-css.e-checkbox-wrapper .e-label {
  font-size: 14px !important;
}
.e-accordion .e-acrdn-item .e-acrdn-header .e-toggle-icon {
  display: table;
  font-size: 14px;
  height: 40px;
  min-height: 40px;
  min-width: 24px;
  position: absolute;
  right: 15px;
  top: 0;
  color: #1b70bb !important;
}
.accordionUl {
  list-style: none;
}
.accordionUl li {
  line-height: 25px;
}
.inputs-div {
  margin: 30px 0;
}
#dialog_dialog-header {
  padding: 0 30px;
  background-color: #0071bb;
}
.e-dlg-header h3 {
  margin-top: 10px !important;
}
input[type=text] {
  height: 34px !important;
  font-size: 14px !important;
}
.fa.fa-search {
  height: 24px !important;
  font-size: 18px;
  color: #333;
}
.e-ddl.e-input-group input.e-input::selection {
  color: #fff;
  background-color: #0071bb;
}
.active {
  font-weight: bold !important;
  background-color: #eed;
}
.ejsChk {
  padding: 4px;
}
.fa-arrow-up {
  padding-right: 5px;
}
.searchButton {
  border-color: #c8c8c8;
}
.buttons-div {
  padding: 20px;
}
.numbers-span {
  font-size: 14px;
  padding: 0 5px;
  color: #333;
}
#dialog_dialog-header h3 {
  color: #fff !important;
}
.e-footer-content {
  width: 100% !important;
}
/*# sourceMappingURL=attributes-modal.component.css.map */
